import classNames from 'clsx';
import { ReactComponent as AppQRCode } from 'img/errors/app-qrcode.svg';
import { ReactComponent as CuteCat } from 'img/errors/cute-cat.svg';
import React, { memo } from 'react';
import { DisableButtonComponent } from 'reactApp/ui/AdvBanners/DisableButton/DisableButtonComponent';
import { DownloadAppButtonComponent } from 'reactApp/ui/Mobile/DownloadAppButton/DownloadButtonComponent';
import { ON_PREMISE } from 'server/constants/environment';

import { ErrorPageButton } from './components/ErrorPageButton';
import styles from './ErrorPage.css';
import { disableAdvButtonHref, ERROR_STATUS_MAP } from './ErrorPage.helpers';
import { IProps } from './ErrorPage.types';

export const ErrorPageBlock = memo<IProps>(({ status, onButtonClick, advDomIdDesktop, children }) => {
    const { title, annotation, buttonLink, buttonText, imageSrc } = ERROR_STATUS_MAP[status];

    return (
        <div className={styles.container} data-qa-id={status}>
            <div className={styles.wrapper}>
                <div className={styles.root}>
                    <img className={styles.error} src={imageSrc} />
                    <div className={styles.description}>
                        <div className={styles.title}>{title}</div>
                        <div className={styles.annotation}>{annotation}</div>
                        <ErrorPageButton link={buttonLink} text={buttonText} onClick={onButtonClick} />
                    </div>
                </div>

                {!ON_PREMISE && (
                    <>
                        <div className={styles.downloadAppContainer}>
                            <div className={styles.cuteCat}>
                                <CuteCat />
                            </div>
                            <div className={styles.qrcodeContainer}>
                                <div className={styles.qrcode}>
                                    <AppQRCode />
                                </div>
                                <div className={styles.qrcodeText}>
                                    Установите приложение, чтобы ваши файлы и&nbsp;фото всегда были под рукой
                                </div>
                            </div>
                        </div>


                        <div className={styles.appButton}>
                            <DownloadAppButtonComponent
                                linkToDownload="https://trk.mail.ru/c/c9zgc1"
                                text="Установить приложение"
                                showIcon
                            />
                        </div>

                    </>
                )}
            </div>
            <div className={styles.advDesktop}>
                {children || (
                    <div className={classNames(styles.advHeaderStatic, 'js-header-error-page')}>
                        <h3 className={styles.advTitle}>Реклама</h3>
                        <DisableButtonComponent text="Отключить" href={disableAdvButtonHref} />
                    </div>
                )}
                <div id={advDomIdDesktop} data-qa-id="Sidebar" />
            </div>
        </div>
    );
});

ErrorPageBlock.displayName = 'ErrorPageBlock';
